import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["country", "region"]
  static values = { regions: Object, selectedRegion: String }

  connect() {
    this.regionLabel = this.element.querySelector(`label[for="${this.regionTarget.id}"]`)
    this.updateRegion()
    this.dispatch("connected")
  }

  shouldHideRegion() {
    return this.countryTarget.disabled || !(this.isUnitedStates() || this.isCanada())
  }

  isCanada() {
    return this.countryTarget.value === "ca"
  }

  isUnitedStates() {
    return this.countryTarget.value === "us"
  }

  updateRegion() {
    this.populateRegionOptions()
    this.regionTarget.classList.toggle("hidden", this.shouldHideRegion())
    this.regionTarget.toggleAttribute("disabled", this.shouldHideRegion())

    this.updateRegionLabel()
  }

  populateRegionOptions() {
    let regions = []
    const countryCode = this.countryTarget.value.toUpperCase()
    if (Object.keys(this.regionsValue).includes(countryCode)) {
      regions = Object.values(this.regionsValue[countryCode])
    }

    this.regionTarget.innerHTML = ""
    regions.forEach(regionName => {
      const option = document.createElement("option")
      option.value = regionName
      option.textContent = regionName
      option.selected = (regionName === this.selectedRegionValue)
      this.regionTarget.appendChild(option)
    })
  }

  updateRegionLabel() {
    if (!this.regionLabel) {
      return
    }

    if (this.isUnitedStates()) {
      this.regionLabel.innerText = "State"
    } else if (this.isCanada()) {
      this.regionLabel.innerText = "Province"
    }

    this.regionLabel.classList.toggle("hidden", this.shouldHideRegion())
  }
}
